<div class="task-bar" id="taskBarMobile">
    @for(taskBarMenuItem of taskBarMenuItems; track taskBarMenuItem.content) {
    <button [disabled]="$isNavigationDisabled | async" type="button" class="{{taskBarMenuItem.className}}"
        [routerLink]="taskBarMenuItem.routerLink" id="taskBarButton_{{ taskBarMenuItem.buttonName }}"
        [ngClass]="isButtonSelected(taskBarMenuItem.buttonName)">
        @if(taskBarMenuItem.hasSelection){
        <img src="{{taskBarMenuItem.imgSrc}}" alt="Snow" class="task-bar__image img-not-selected">
        <img src="{{taskBarMenuItem.selectedImgSrc}}" alt="Snow" class="task-bar__image img-selected">
        }
        @else {
        <img src="{{taskBarMenuItem.imgSrc}}" alt="Snow" class="task-bar__image">
        }
        <span class="task-bar-button__name">{{taskBarMenuItem.content}}</span>
    </button>
    }
</div>